module.exports = __webpack_public_path__ + "images/category_lp/brand_samples/pattern_new2/sp/item_04_0bebc0ecc087cc71d8a4910ae7c729b0.jpg";